<template>
  <div class="global-content over-hidden">
    <div class="el-icon-warning total-title left"></div>
    <div class="left">合计:</div>
    <div class="left" v-if="isSHow">(本页/总体)</div>
    <template>
      <div class="total-item left" v-for="items in totalList">
        <div class="item-title left">{{ items.title }}:</div>
        <div class="num left">{{ moneyTrans(items.currentNum) }}</div>
        <div class="line left" v-if="totalType == 2 ? true : false">/</div>
        <span class="num left" v-if="totalType == 2 ? true : false">{{
          moneyTrans(items.totalNum)
        }}</span>
      </div>
    </template>
  </div>
</template>
<script>
import { formatMoney } from "@/api/dataTrans";
export default {
  props: ["type"],
  computed: {
    isSHow() {
      console.log(this.totalType)
      if (this.totalType) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      totalList: [],
      totalType: this.type,
    };
  },
  mounted() {
    console.log(111111, this.totalType);
  },
  methods: {
    //初始数据
    initData(_list) {
      this.totalList = _list;
      // console.log(this.totalList)
    },
    //货币形式转换
    moneyTrans(_val) {
      return formatMoney(_val);
    },
  },
};
</script>
<style lang="scss" scoped>
$active: #05A7EA;
.over-hidden {
  overflow: hidden;
}
.global-content {
  padding-top: 8px;
  background-color: rgba(19, 194, 194, 0.05);
  border-radius: 4px;
  margin-bottom: 16px;
  // border: 1px solid $active;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
  .left {
    float: left;
  }
  .total-title {
    display: inline-block;
    margin-left: 24px;
    margin-right: 8px;
    margin-top: 2px;
  }
  .el-icon-warning:before {
    color: $active;
  }
  .total-item {
    padding-bottom: 8px;
    .item-title {
      margin-right: 5px;
    }
    margin-left: 24px;
    .num {
      color: $active;
    }
    .line {
      padding: 0px 5px;
    }
  }
}
</style>